import initTabs from './components/tabs';
import initSelects from './components/select';
import initProjects from './components/projects';
import initPressCenter from './components/press-center';
import initHistory from './components/history';
import initYoutube from './components/youtube';
import initYoutubePopup from './components/youtube-popup';
import initGallery from './components/gallery';
import initSquareMap from './components/square-map';
import initMobileNav from './components/mobile-nav';
import initSearch from './components/search';

import './utils/requestAnimationFrame';

document.addEventListener('DOMContentLoaded', () => {
  initTabs();
  initSelects();
  initProjects();
  initPressCenter();
  initHistory();
  initYoutube();
  initYoutubePopup();
  initGallery();
  initMobileNav();
  initSquareMap();
  initSearch();
});



// WEBPACK FOOTER //
// ./assets/scripts/index.js